"use strict";
/// <reference path="../../../Trillium.UI/TypeScript/Models/Website/ListDocumentViewModel.tsx"/>
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var moment_1 = __importDefault(require("moment"));
var core_1 = require("@material-ui/core");
var FolderListModal_1 = __importDefault(require("./FolderListModal"));
var ListFolders_1 = __importDefault(require("./ListFolders"));
var DocumentLibraryService_1 = __importDefault(require("../../../Trillium.UI/TypeScript/Services/DocumentLibrary/DocumentLibraryService"));
var lab_1 = require("@material-ui/lab");
var convertBytesToKB = function (bytes) { return Math.round(bytes / 1000); };
var service = new DocumentLibraryService_1.default();
var pageSize = 10;
var ListDocuments = function (props) {
    var _a;
    var _b = react_1.useState(''), isEdit = _b[0], setIsEdit = _b[1];
    var _c = react_1.useState(''), textVal = _c[0], setTextVal = _c[1];
    var _d = react_1.useState({ open: false, action: '', message: '', error: false }), alertModalDetails = _d[0], setAlertModalDetails = _d[1];
    var _e = react_1.useState({ open: false, docFolder: '', selectFolder: { Id: '', Url: '' }, error: false }), moveModalDetails = _e[0], setMoveModalDetails = _e[1];
    var _f = react_1.useState([]), error = _f[0], setError = _f[1];
    var _g = react_1.useState(props.deleteErrorMessage), errorMessage = _g[0], setErrorMessage = _g[1];
    var _h = react_1.useState(true), isFolderList = _h[0], setIsFolderList = _h[1];
    var _j = react_1.useState([]), documents = _j[0], setDocuments = _j[1];
    var _k = react_1.useState({}), pagination = _k[0], setPagination = _k[1];
    react_1.useEffect(function () {
        setError(props.errorList);
        var f = props.FolderList.find(function (a) { return a.Name === props.HeaderText; });
        if (f)
            setIsFolderList(true);
        else
            setIsFolderList(false);
        var res = [];
        var map = {};
        var folderPagination = {};
        props.Documents.forEach(function (item) {
            var _a, _b;
            var temp = {};
            var f = (_a = item.ParentFolder) !== null && _a !== void 0 ? _a : props.HeaderText;
            if (!map[f]) {
                map[f] = [];
                temp[f] = map[f];
                res.push(temp);
            }
            ;
            map[f].push(item);
            folderPagination[f] = { pageNo: 1, totalItems: (_b = map[f]) === null || _b === void 0 ? void 0 : _b.length };
        });
        var sortedList = res.sort(function (a, b) {
            var aName = Object.keys(a)[0].toLowerCase();
            var bName = Object.keys(b)[0].toLowerCase();
            return aName < bName ? -1 : aName > bName ? 1 : 0;
        });
        setPagination(folderPagination);
        setDocuments(sortedList);
    }, [props]);
    var retrieveFoldersAndFiles = function () { return __awaiter(void 0, void 0, void 0, function () {
        var f;
        return __generator(this, function (_a) {
            try {
                f = props.FolderList.find(function (f) { return f.Name === props.HeaderText; });
                if (f)
                    props.RetrieveDocuments({ Url: f.Url, Name: f.Name });
                else if (props.HeaderText)
                    props.SearchItems();
                else
                    props.RetrieveDocuments({ Name: '' });
            }
            catch (err) { }
            ;
            return [2 /*return*/];
        });
    }); };
    var handletxtChange = function (e, ext) {
        setTextVal(e.target.value + "." + ext);
    };
    var onPageChange = function (folder, page) {
        var _a;
        setPagination(__assign(__assign({}, pagination), (_a = {}, _a[folder] = __assign(__assign({}, pagination[folder]), { pageNo: page }), _a)));
    };
    var moveDocumentFile = function (fileUrl, folderUrl) { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    console.log(fileUrl, folderUrl);
                    return [4 /*yield*/, service.moveFile(fileUrl, folderUrl)];
                case 1:
                    response = _a.sent();
                    if (response.Success) {
                        retrieveFoldersAndFiles();
                        closeMoveModal();
                        closeAlertModal();
                        setIsEdit('');
                    }
                    else {
                        setAlertModalDetails(__assign(__assign({}, alertModalDetails), { message: 'something went wrong' }));
                        setMoveModalDetails(__assign(__assign({}, moveModalDetails), { error: true }));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    return [3 /*break*/, 3];
                case 3:
                    ;
                    return [2 /*return*/];
            }
        });
    }); };
    var moveFileCondition = function (docList, name) {
        var newName = name;
        var one = docList.find(function (f) { return f.Name === newName; });
        if (one) {
            var s = newName.split(".");
            return moveFileCondition(docList, s[0] + "(1)." + s[1]);
        }
        else
            return newName;
    };
    var moveFile = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, newName;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(moveModalDetails.selectDoc && moveModalDetails.selectFolder.Url)) return [3 /*break*/, 2];
                    return [4 /*yield*/, service.getFolderWithRelatedItems(props.MembershipNumber, moveModalDetails.selectFolder.Name)];
                case 1:
                    res = _a.sent();
                    if (res.Success && res.Result) {
                        newName = moveFileCondition(res.Result, moveModalDetails.selectDoc.Name);
                        if (newName !== moveModalDetails.selectDoc.Name)
                            openAlertModal('move', moveModalDetails.selectFolder);
                        else
                            moveDocumentFile(moveModalDetails.selectDoc.Url, moveModalDetails.selectFolder.Url + '/' + moveModalDetails.selectDoc.Name);
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var deleteFile = function (fileUrl) {
        deleteDocumentFile([fileUrl]);
    };
    var deleteDocumentFile = function (fileUrls) { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, service.deleteDocumentFile(fileUrls)];
                case 1:
                    response = _a.sent();
                    if (response.Success) {
                        closeAlertModal();
                        retrieveFoldersAndFiles();
                    }
                    else {
                        setAlertModalDetails(__assign(__assign({}, alertModalDetails), { message: 'something went wrong', error: true }));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    setAlertModalDetails(__assign(__assign({}, alertModalDetails), { message: 'something went wrong' }));
                    return [3 /*break*/, 3];
                case 3:
                    ;
                    return [2 /*return*/];
            }
        });
    }); };
    var renameFile = function (fileUrl) {
        renameDocumentFile(fileUrl, textVal);
    };
    var renameDocumentFile = function (fileUrl, fileName) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, service.renameDocumentFile(fileUrl, fileName)];
                case 1:
                    response = _a.sent();
                    if (response.Success) {
                        retrieveFoldersAndFiles();
                        closeAlertModal();
                        setIsEdit('');
                    }
                    else {
                        setAlertModalDetails(__assign(__assign({}, alertModalDetails), { message: 'something went wrong', error: true }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var dowanloadFile = function (fileUrl) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            window.open("/umbraco/api/IPDDocumentLibraryAPI/getdownload?fileUrl=" + encodeURIComponent(fileUrl));
            return [2 /*return*/];
        });
    }); };
    var cancelClick = function () {
        setIsEdit('');
        setTextVal('');
        setError([]);
    };
    var editClick = function (doc) {
        setIsEdit(doc.Id);
        setTextVal(doc.Name);
    };
    var handleChange = function (e) {
        var newArray = [];
        if (e.currentTarget.checked) {
            newArray = props.multiselectedDoc.concat(e.currentTarget.value);
        }
        else {
            newArray = props.multiselectedDoc.filter(function (a) { return a !== e.currentTarget.value; });
        }
        props.onSelectChange(newArray);
    };
    var openAlertModal = function (action, data) {
        var _a;
        if (data.Attributes && JSON.parse(data.Attributes).length && action === 'delete') {
            setError([data.Id]);
            setErrorMessage(props.deleteErrorMessage);
            return;
        }
        else if (action === 'save') {
            if (!((_a = textVal.split(".")[1]) === null || _a === void 0 ? void 0 : _a.length)) {
                setAlertModalDetails({ open: true, action: action, data: data, message: "File name is not valid", error: false });
                return;
            }
            var sameNameFile = props.Documents.find(function (n) { return n.Name === textVal; });
            if (sameNameFile)
                setAlertModalDetails({ open: true, action: action, data: data, message: props.sameErrorMessage, error: false });
            else
                setAlertModalDetails({ open: true, action: action, data: data, error: false, message: props.editAlertMessage });
        }
        else if (action === 'move') {
            setAlertModalDetails({ open: true, action: action, data: data, message: props.moveErrorMessage, error: false });
            return;
        }
        else
            setAlertModalDetails({ open: true, action: action, data: data, error: false });
    };
    var closeAlertModal = function () {
        setAlertModalDetails({ open: false, action: '' });
    };
    var openMoveModal = function (data) {
        var _a;
        setMoveModalDetails({ open: true, selectFolder: { Id: '', Url: '' }, selectDoc: data, docFolder: (_a = data.ParentFolder) !== null && _a !== void 0 ? _a : props.HeaderText, error: false });
    };
    var closeMoveModal = function () {
        setMoveModalDetails({ open: false, selectFolder: { Id: '', Url: '' } });
    };
    var onFolderSelect = function (data) {
        setMoveModalDetails(__assign(__assign({}, moveModalDetails), { selectFolder: data }));
    };
    var modalAction = function () {
        switch (alertModalDetails.action) {
            case 'delete':
                if (alertModalDetails.data)
                    deleteFile(alertModalDetails.data.Url);
                break;
            case 'save':
                if (alertModalDetails.data)
                    renameFile(alertModalDetails.data.Url);
                break;
            case 'move':
                if (moveModalDetails.selectDoc)
                    moveDocumentFile(moveModalDetails.selectDoc.Url, moveModalDetails.selectFolder.Url + '/' + moveModalDetails.selectDoc.Name);
            default:
                break;
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "card mb-15" },
            react_1.default.createElement("div", { className: "card-body" },
                !isFolderList ? react_1.default.createElement("h2", { className: "card-title" },
                    props.Documents.length,
                    " ",
                    props.Documents.length > 1 ? props.documentsTitle : props.documentTitle) : null,
                documents.length ? documents.map(function (docf) { return react_1.default.createElement("div", { className: "row", key: Object.keys(docf)[0] },
                    react_1.default.createElement("div", { className: "col" },
                        react_1.default.createElement("h4", { className: "card bg-light border-0 p-2 px-4 mb-2 d-flex flex-row align-items-center" },
                            isFolderList ? react_1.default.createElement("i", { className: "fas fa-folder mr-3 mt-1 icon-ice-lake" }) : react_1.default.createElement("i", { className: "fas fa-search mr-3 mt-1 icon-ice-lake" }),
                            Object.keys(docf)[0],
                            " (",
                            docf[Object.keys(docf)[0]].length,
                            ")"),
                        docf[Object.keys(docf)[0]].slice((pagination[Object.keys(docf)[0]].pageNo - 1) * pageSize, ((pagination[Object.keys(docf)[0]].pageNo - 1) * pageSize) + pageSize).map(function (document) {
                            return react_1.default.createElement("div", { className: "row mt-2", key: document.Id },
                                react_1.default.createElement("div", { className: "col" },
                                    react_1.default.createElement("div", { className: "card d-flex flex-column" },
                                        react_1.default.createElement("div", { className: "card-body" },
                                            error.includes(document.Id) ? react_1.default.createElement("div", { className: "alert-warning mb-20" }, errorMessage) : null,
                                            react_1.default.createElement("div", { className: "row" },
                                                react_1.default.createElement("div", { className: "col-md-7 d-flex flex-row" },
                                                    react_1.default.createElement("div", { className: "pr-4 pt-2" }, props.isTrainee ? react_1.default.createElement("input", { type: "checkbox", className: "ipd-checkbox", onChange: function (e) { return handleChange(e); }, value: document.Id, checked: props.multiselectedDoc.includes(document.Id) }) : null),
                                                    react_1.default.createElement("div", { className: "d-flex flex-column flex-grow-1" },
                                                        react_1.default.createElement("div", { className: "bordered-filename" }, isEdit === document.Id ? react_1.default.createElement("input", { type: "text", id: "fname", name: "txtfilename", className: 'file-name-input', onChange: function (e) { return handletxtChange(e, document.Name.split('.').pop()); }, defaultValue: document.Name.substring(0, document.Name.lastIndexOf('.')) })
                                                            : react_1.default.createElement("span", { className: 'file-name', onClick: function () { return dowanloadFile(document.Url); } }, document.Name)),
                                                        react_1.default.createElement("div", { className: "mt-2 colorchocolate" },
                                                            " ",
                                                            convertBytesToKB(document.FileSizeRaw),
                                                            "KB, modified ",
                                                            moment_1.default(document.Modified).fromNow()))),
                                                props.isTrainee ? react_1.default.createElement("div", { className: "col-md-5" },
                                                    react_1.default.createElement("div", { className: "row" }, isEdit === document.Id ? react_1.default.createElement(react_1.default.Fragment, null,
                                                        react_1.default.createElement("div", { className: "col" },
                                                            react_1.default.createElement("a", { className: "mt-2 mt-md-0 btn btn-primary btn-primary-outline col-12 mb-4", onClick: function () { return openMoveModal(document); } }, props.moveButton),
                                                            react_1.default.createElement("a", { className: "mt-2 mt-md-0 btn btn-primary btn-primary-outline col-12", onClick: function () { return cancelClick(); } }, props.cancleButton)),
                                                        react_1.default.createElement("div", { className: "col" },
                                                            react_1.default.createElement("a", { className: "mt-2 mt-md-0 btn btn-danger col-12 mb-4", onClick: function () { return openAlertModal('delete', document); } }, props.deleteButton),
                                                            react_1.default.createElement("a", { className: "mt-2 mt-md-0 btn btn-primary col-12", onClick: function () { return openAlertModal('save', document); } }, props.saveButton)))
                                                        : react_1.default.createElement("div", { className: "col-md-6 ml-auto" },
                                                            react_1.default.createElement("a", { className: "mt-2 mt-md-0 btn btn-primary btn-primary-outline col-12 mb-4", onClick: function () { return editClick(document); } }, props.editButton)))) : null),
                                            document.Attributes && typeof JSON.parse(document.Attributes) === 'object' ?
                                                react_1.default.createElement("div", { className: "row mt-3 ml-4" },
                                                    react_1.default.createElement("div", null,
                                                        react_1.default.createElement("div", { className: "font-weight-bold pt-3 mr-3 assignedto" }, props.assignToText)),
                                                    react_1.default.createElement("div", { className: 'attribute-list' }, JSON.parse(document.Attributes).map(function (a, i) { return a.name ? (react_1.default.createElement("div", { className: "ml-3 mb-3", key: i },
                                                        react_1.default.createElement("div", { className: "orange-attribute" }, a.name))) : null; }))) : null))));
                        }),
                        Math.ceil(pagination[Object.keys(docf)[0]].totalItems / pageSize) > 1 ?
                            react_1.default.createElement(lab_1.Pagination, { className: 'pagination', count: Math.ceil(pagination[Object.keys(docf)[0]].totalItems / pageSize), page: pagination[Object.keys(docf)[0]].pageNo, onChange: function (e, p) { return onPageChange(Object.keys(docf)[0], p); } })
                            : null)); })
                    : (react_1.default.createElement("div", { className: "card d-flex flex-column mt-2 p-40 text-center" },
                        react_1.default.createElement("i", { className: "pdf-icon fas fa-file-pdf mb-30" }),
                        react_1.default.createElement("h4", null, props.emptyFolderHeader),
                        react_1.default.createElement("div", null, props.emptyFoldersecondHeader))))),
        react_1.default.createElement(FolderListModal_1.default, { open: moveModalDetails.open, onClose: closeMoveModal, onContinue: moveFile, anySelect: moveModalDetails.selectFolder.Id, cancleButton: props.cancleButton, moveButton: props.moveButton, error: moveModalDetails.error },
            react_1.default.createElement(ListFolders_1.default, { HeaderText: props.moveFolderheader, Folders: props.FolderList.filter(function (x) { return x.Type === 'folder' && x.Name !== moveModalDetails.docFolder; }), onFolderclick: onFolderSelect, selectFolder: (_a = moveModalDetails.selectFolder) === null || _a === void 0 ? void 0 : _a.Id })),
        react_1.default.createElement(core_1.Dialog, { open: alertModalDetails.open, onClose: function () { return closeAlertModal(); }, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
            react_1.default.createElement(core_1.DialogTitle, { id: "alert-dialog-title" }, props.areYouSure),
            react_1.default.createElement(core_1.DialogContent, null,
                react_1.default.createElement(core_1.DialogContentText, { id: "alert-dialog-description" }, alertModalDetails.message ? alertModalDetails.message : props.alertMessage)),
            react_1.default.createElement(core_1.DialogActions, null,
                react_1.default.createElement(core_1.Button, { onClick: function () { return closeAlertModal(); } }, props.cancleButton),
                !alertModalDetails.error ? react_1.default.createElement(core_1.Button, { onClick: function () { return modalAction(); } }, props.continueButton) : null))));
};
exports.default = ListDocuments;
